import React from "react";

import { ROUTES } from "constants/routes";

/* Auth */
const Login = React.lazy(() => import("pages/admin-flow/login"));

/* Places */
const PlacesList = React.lazy(() => import("pages/admin-flow/places/list"));
const PlcaseUpload = React.lazy(() => import("pages/admin-flow/places/upload"));
const PlaceOverview = React.lazy(
  () => import("pages/admin-flow/places/overview")
);
const PlacesAvailability = React.lazy(
  () => import("pages/admin-flow/places/availability")
);

/* Best Biking Roads */
const BestBikingRoadsList = React.lazy(
  () => import("pages/admin-flow/best-biking-roads")
);
const BestBikingRoadsCreate = React.lazy(
  () => import("pages/admin-flow/best-biking-roads/create")
);

/* Graphhopper Keys */
const GraphhopperKeys = React.lazy(
  () => import("pages/admin-flow/graphhopper-keys")
);

/* Routes */
const RoutesList = React.lazy(() => import("pages/admin-flow/routes/list"));
const BuildRoute = React.lazy(() => import("pages/admin-flow/routes/build"));

/* Other */
const Tags = React.lazy(() => import("pages/admin-flow/tags"));
const Widgets = React.lazy(() => import("pages/admin-flow/widgets"));
const TestResponse = React.lazy(() => import("pages/admin-flow/test-response"));

export const routes = {
  auth: [
    {
      path: ROUTES.Login,
      element: <Login />,
    },
  ],
  private: [
    // Places
    { path: ROUTES.Places.List, element: <PlacesList /> },
    { path: ROUTES.Places.Upload, element: <PlcaseUpload /> },
    { path: ROUTES.Places.Overview, element: <PlaceOverview /> },
    { path: ROUTES.Places.Availability, element: <PlacesAvailability /> },

    // Best Biking Roads
    { path: ROUTES.BestBikingRoads.List, element: <BestBikingRoadsList /> },
    { path: ROUTES.BestBikingRoads.Create, element: <BestBikingRoadsCreate /> },

    // Graphhopper Keys
    { path: ROUTES.GraphhopperKeys.Home, element: <GraphhopperKeys /> },

    // Routes
    { path: ROUTES.Routes.Build, element: <BuildRoute /> },
    { path: ROUTES.Routes.List, element: <RoutesList /> },

    // Other
    { path: ROUTES.Tags, element: <Tags /> },
    { path: ROUTES.Widgets, element: <Widgets /> },
    { path: "/test-response", element: <TestResponse /> },
  ],
};
